import classNames from "classnames";

// eslint-disable-next-line postcss-modules/no-unused-class
import style from "./CTARowDivider.module.css";

interface CTARowDividerProps {
  className?: string;
  variant?: "top" | "bottom" | "both" | "none";
}

export const CTARowDivider: React.FC<CTARowDividerProps> = ({ variant = "both", className }) => {
  return <hr className={classNames(style.divider, style[variant], className)} />;
};
